import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'

export default function Content17({data}) {
    const {content17Subtitle, content17Title, content17Blocks, content17Image} = data
    return (
        <div className='image-with-content-wrap p-line-25'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center mb-4'>
                        <h2 className='heading-level-2 blue-color w-g-c-title'>
                            {content17Title && parser(content17Title)}
                        </h2>
                        <p>
                            <strong>{content17Subtitle && parser(content17Subtitle)}</strong>
                        </p>
                    </div>
                    <div className='col-md-6'>
                        <figure>
                            <GatsbyImage
                                image={getImage(content17Image?.localFile)}
                                alt='image'
                            />
                        </figure>
                    </div>
                    <div className='col-md-6'>
                        <div className='img-with-content-rt-sec'>
                            {content17Blocks?.map((block, index) => (
                                <React.Fragment key={index}>
                                    <div className='heading-level-6 blue-color'>
                                        {block.content17BlockTitle && parser(block.content17BlockTitle)}
                                    </div>
                                    <p>{block.content17BlockText && parser(block.content17BlockText)}</p>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
